import {useEffect, useState, useRef} from 'react';
import {getAllInvoices, insertInvoicePayment} from "../../api/Api";
import {Button, message, Table, Popover} from 'antd';
import {AddPaymentWidget} from "./AddPaymentWidget";
import {InvoiceStatusType} from "../../api/Constants";
import {Link} from "react-router";
import {InvoiceStateWidget} from "./InvoiceStateWidget";
import {getColumnSearchProps} from "../widget/SearchProps";

export const ExistingInvoice = ({refreshInvoice, onRefresh, onApiFail, props}) => {
    const [invoices, setInvoices] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();
    const [reload, setReload] = useState(0);

    useEffect(() => {
        getAllInvoices().then(result => {
            setInvoices(result.map(i => {
                return {...i,
                    key: i.id
                }
            }).filter(i => i.state <= InvoiceStatusType.PartialPayment));
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [refreshInvoice, onApiFail, reload]);

    const [isPaymentOpen, setIsPaymentOpen] = useState(false);
    const [paymentInvoice, setPaymentInvoice] = useState(undefined);

    const openPaymentModal = (invoice) => () => {
        setIsPaymentOpen(true);
        setPaymentInvoice(invoice);
    }

    const getBalance = (record) => {
        const floatVal = record.subtotal - record.amountPaid;
        const fixedVal = floatVal.toFixed(2);
        return parseFloat(fixedVal);
    }

    const onPaymentOk = (amount, bankId, notes) => {
        const invoiceId = paymentInvoice.id;
        console.log(`inserting payment for invoice ${invoiceId} ${amount}`);
        insertInvoicePayment(invoiceId, amount, bankId, notes).then(r => {
            messageApi.open({
                type: 'success',
                content: 'Payment Added Successfully',
            });
            if (onRefresh) onRefresh();
            setReload(reload+1);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
            messageApi.open({
                type: 'error',
                content: 'Add Payment Failed',
            });
        })
        setIsPaymentOpen(false);
    }

    const onPaymentCancel = () => {
        setIsPaymentOpen(false);
    }

    // for use with search props
    const searchInput = useRef(null);

    const columns = [
        {
            title: 'Invoice Number',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber',
            render: (val, record, index) => {
                return <Link to={`/invoice/${record.id}`}>{val}</Link>
            },
            ...getColumnSearchProps(`invoiceNumber`, searchInput),
            sorter: (a, b) => a.invoiceNumber.toLowerCase().localeCompare(b.invoiceNumber.toLowerCase()),
        },
        {
            title: 'Buyer',
            dataIndex: 'firstname',
            render: (val, record, index) => {
                return `${val} ${record.lastname}`
            },
            ...getColumnSearchProps(`firstname`, searchInput),
            sorter: (a, b) => {
                const aName = `${a.firstname} ${a.lastname}`;
                const bName = `${b.firstname} ${b.lastname}`;
                return aName.localeCompare(bName);
            }
        },
        {
            title: 'Created by',
            dataIndex: 'username',
            key: 'username',
            sorter: (a, b) => a.username.localeCompare(b.username)
        },
        {
            title: 'Date',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val) => {
                const terms = val.split("T");
                return terms[0]
            },
            sorter: (a, b) => (new Date(a.timestamp))- (new Date(b.timestamp)),
        },
        {
            title: 'Status',
            dataIndex: 'state',
            key: 'state',
            render: (val, record, index) => {
                // return InvoiceStatusType.Label[val];
                return <InvoiceStateWidget invoice={record} onApiFail={onApiFail} onRefresh={onRefresh} disabled={false}/>
            },
            sorter: (a, b) => a.state - b.state
        },
        {
            title: 'Subtotal',
            dataIndex: 'subtotal',
            key: 'subtotal',
            render: (val) => {
                return `$ ${val}`;
            },
            sorter: (a, b) => a.subtotal - b.subtotal,
        },
        {
            title: 'Paid',
            dataIndex: 'amountPaid',
            key: 'amountPaid',
            render: (val, record, index) => {
                return <div onClick={openPaymentModal(record)} style={{cursor: 'pointer'}}>$ {val}</div>;
            },
            sorter: (a, b) => a.amountPaid - b.amountPaid,
        },
        {
            title: 'Balance',
            dataIndex: 'subtotal',
            key: 'balance',
            render: (val, record, index) => {
                const balance = getBalance(record);
                return `$ ${balance}`
            },
            sorter: (a, b) => {
                const aBalance = a.subtotal - a.amountPaid;
                const bBalance = b.subtotal - b.amountPaid;
                return aBalance - bBalance;
            },
        },
        {
            title: 'Add Payment',
            dataIndex: 'amountPaid',
            key: 'AddPayment',
            render: (val, record, index) => {
                return <Popover content={`Pay invoice ${record.invoiceNumber}`}>
                    <Button onClick={openPaymentModal(record)}>Pay</Button>
                </Popover>
            }
        }
    ];

    const remainingBalance = (paymentInvoice) ? getBalance(paymentInvoice) : 0;

    return <>
        {contextHolder}
        <AddPaymentWidget open={isPaymentOpen} remainingBalance={remainingBalance}
            onOk={onPaymentOk} onCancel={onPaymentCancel}/>
        <Table dataSource={invoices} columns={columns} />
    </>
}